$('.form__select select').select2({
  minimumResultsForSearch: -1,
  width: '100%',
});
$('.form-history__select select').select2({
  minimumResultsForSearch: -1,
  width: '100%',
});
